/**
 * Стан згортання секцій картки (REC-03): межі й форма запису. Без zod і імпортів, як `./text-rules`:
 * один регекс і одна межа для схеми `/me/preferences` (`settings.ts`) і для `cl:prefs` у вебі, який
 * не тягне zod у перший екран.
 */

/** Межа записів стану секцій: ~50 сутностей × кілька секцій, ≤ 26 КБ у сховищі. */
export const RECORD_SECTIONS_MAX = 200;

/**
 * Запис стану секції: `<сутність>/<секція>=1|0` (1 — розгорнута, 0 — згорнута). Ключі — канонічні
 * фізичні імена (metadata-ui.md, розд. 1); ПД у записі немає, лише імена метаданих. Перемикач
 * стрічки елемента макета зв'язків (#1229) — `<сутність>/feed:<елемент>=1|0`: окремий префікс, щоб
 * не ділити стан із секцією того самого ключа.
 */
export const RECORD_SECTION_ENTRY = /^[a-z][a-z0-9_]{0,62}\/(feed:)?[a-z][a-z0-9_]{0,62}=[01]$/;
